jQuery(document).ready(function ($) {


    const $careers_types = $('.careers-types');
    const $positions_list = $('.positions__list');
    const $positions_not_found = $('.positions__list--not-found');
    const $position_boxes = $('.position-box');
    const get_position_boxs_parents = () => $position_boxes.parent();

    const get_box_parents_fadeIn = (current_type_id) => {
        const elements = [];
        $position_boxes.each( function () {
            const $this_box = $(this);
            const $box_parent = $this_box.parent();
            let type_ids = $this_box.data('type_ids').toString().trim().split(',');
            type_ids = type_ids.map( ( currentValue ) => {
                if( currentValue.toString() === current_type_id )
                    return $box_parent;
                return null;
            });
            type_ids = type_ids.filter( currentValue => currentValue );
            type_ids.length && elements.push(type_ids[0]);
        });
        return elements;
    };

    $careers_types.find('[data-type_id]').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $parent = $this.parent();
        const current_type_id = $this.data('type_id').toString();

        $careers_types.find('.-pre-active').removeClass('-pre-active');
        $parent.addClass('-pre-active');

        $positions_list.fadeOut(function () {
            get_position_boxs_parents().hide();
            $(this).fadeIn();
            $positions_not_found.hide();
            if( ! window.parseInt( current_type_id ) ) {
                get_position_boxs_parents().fadeIn();
            }
            else {
                const $box_parents = get_box_parents_fadeIn( current_type_id );
                if( $box_parents.length ) {
                    $box_parents.map( $box_parent => $box_parent.fadeIn() );
                }
                else {
                    $positions_not_found.fadeIn( function () {
                        $(this).focus();
                    });
                }
            }
        });
    })
});